import EbisSingleDatePickerInput from './EbisDatepickerInput';

export default EbisSingleDatePickerInput;
